import { Dialog } from "primereact/dialog";
import { SkeletonContainer } from "../Loader/Loader";
import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts';
import Highcharts3D from "highcharts/highcharts-3d";
import DatePicker from "react-multi-date-picker";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHitsService } from "../../Hooks/Features/Inspectra/useHitsService";
import { dateConvert, timePickerMuiCss } from "../../utils/Helper";
import { Calendar } from "primereact/calendar";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
Highcharts3D(Highcharts);

const HitsService = ({ autopopData, projectChanged }) => {

    const { filterCount, loader, showFilter, setShowFilter, hoveredRange, filterValues, setFilterValues, showPopup, setShowPopup, popupData, expand, setExpand, allHitOptions, time, setTime, handleDateRange, handleApplyFilters, handleDefaultFilters } = useHitsService({ projectChanged });

    return (
        <div className="inspectra-widget-container">
            <div className="p-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="inspectra-widget-header">Hits per Service</div>
                    <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center" onClick={() => setShowFilter(true)}><span className="inspectra-filter-count">{filterCount}</span>filters</div>
                </div>
                <div className="inspectra-date-string">{dateConvert(filterValues?.date?.from_date, "date-time-months")} - {dateConvert(filterValues?.date?.to_date, "date-time-months")}</div>
            </div>
            <div className="inspectra-widget-content d-flex flex-wrap gap-2">
                {loader ? <SkeletonContainer /> : (
                    allHitOptions?.map((options, index) => {
                        const sizeClass = options.chartSize === 'large' ? 'chart-large' : options.chartSize === 'medium' ? 'chart-medium' : 'chart-small';
                        return (
                            <div key={index} className={sizeClass}>
                                <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} />
                            </div>
                        )
                    })
                )}
                <div className="inspectra-expand-icon fs-6 c-pointer" onClick={() => setExpand(true)}>
                    <FontAwesomeIcon icon="fa-solid fa-expand" />
                </div>
            </div>


            <Dialog visible={showFilter} onHide={() => setShowFilter(false)} className="modal-small" draggable={false} header="Hits per Service Filters">
                <div>
                    <div className="d-flex gap-2 inspectra-calendar">
                        <div className="w50">
                            <div>Date: </div>
                            <div>
                                <DatePicker portal zIndex={99999} value={hoveredRange} onChange={handleDateRange} range rangeHover placeholder="Select Date Range" style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div className="w45 d-flex gap-2 justify-content-between">
                            <div className="w50">
                                <div>From Time: </div>
                                <TimePicker value={time?.from || null} onChange={(e) => setTime((prev) => ({ ...prev, from: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }}
                                    slotProps={{
                                        textField: {
                                            label: undefined,
                                        }
                                    }}
                                />
                            </div>
                            <div className="w50">
                                <div>To Time: </div>
                                <TimePicker value={time?.to || null} onChange={(e) => setTime((prev) => ({ ...prev, to: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }}
                                    slotProps={{
                                        textField: {
                                            label: undefined,
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="w50">
                            <div>Service:</div>
                            <MultiSelect options={autopopData?.service_name} placeholder="Service" value={filterValues?.service} onChange={(e) => setFilterValues((prev) => ({ ...prev, service: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'service', filterValues?.service, () => setFilterValues((prev) => ({ ...prev, service: [] })))} filter filterInputAutoFocus />
                        </div>
                        <div className="w50">
                            <div>Server:</div>
                            <MultiSelect options={autopopData?.server} placeholder="Server" value={filterValues?.server} onChange={(e) => setFilterValues((prev) => ({ ...prev, server: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'server', filterValues?.server, () => setFilterValues((prev) => ({ ...prev, server: [] })))} filter filterInputAutoFocus />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary c-pointer" onClick={() => handleDefaultFilters()}>Select default filters</div>
                        <button className="button btn-primary" onClick={() => handleApplyFilters()}>Apply</button>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={showPopup} onHide={() => { setShowPopup(false); }} draggable={false} className="modal-large inspectra-grey-dialog" header="Hits per Service Details">
                <div>
                    <div className="service-error-list">
                        {popupData?.map((item, index) => (
                            <div key={index} className="service-error-item">
                                <div className="d-flex gap-5">
                                    <div><strong>Project:</strong> {item?.project_name}</div>
                                    <div><strong>Service Type:</strong> {item?.service_type}</div>
                                    <div><strong>Service:</strong> {item?.service_name}</div>
                                </div>
                                <div><strong>Server:</strong> {item?.server}</div>
                                <div><strong>Request Hits:</strong> {item?.requesthits}</div>
                                <div><strong>Create Date:</strong> {new Date(item?.create_date).toLocaleString()}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </Dialog>

            <Dialog visible={expand} onHide={() => setExpand(false)} className="modal-xlarge" draggable={false} header="Hits per Service Expanded">
                <div>
                    <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center justify-content-end" onClick={() => setShowFilter(true)}>
                        <span className="inspectra-filter-count">{filterCount}</span>filters
                    </div>
                    <div className="inspectra-widget-content d-flex flex-wrap gap-2">
                        {loader ? <SkeletonContainer /> : (
                            allHitOptions?.map((options, index) => {
                                const sizeClass = options.chartSize === 'large' ? 'chart-large' : options.chartSize === 'medium' ? 'chart-medium' : 'chart-small';
                                return (
                                    <div key={index} className={sizeClass}>
                                        <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} />
                                    </div>
                                )
                            })
                        )}
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default HitsService;